var site = site || {};
site.inits = [];
var toggle = MoyaContainer.get('core.toggle');

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		MoyaLoader.all([
			'https://static.stefna.is/js/owlcarousel/2.3.4/owl.carousel.min.js',
			'https://static.stefna.is/js/owlcarousel/2.3.4/owl.carousel.min.css',
		]).then(function () {
			var $owl = $(id);
			if ($owl.length > 0) {
				$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
				if (options.nav) {
					options['onInitialized'] = function() {
						$('.owl-next', $owl).attr('role', 'button').attr('aria-label', 'Next');
						$('.owl-prev', $owl).attr('role', 'button').attr('aria-label', 'Prev');
					}
				}
				$owl.owlCarousel(options);
			}
		});
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.frontpageCarousel = {
	$carousel: undefined,
	$initialCarouselHtml: undefined,

	init: function() {
		site.frontpageCarousel.$carousel = $('.frontpage__carousel');
		site.frontpageCarousel.$initialCarouselHtml = site.frontpageCarousel.$carousel.html();

		site.owl.init(site.frontpageCarousel.$carousel, {
			items: 1,
			dots: false,
			nav: true,
			navText: ['', ''],
			lazyLoad: true,
			smartSpeed: 700,
			onChanged: site.frontpageCarousel.playCurrentVideo,
			animateOut: 'fadeOut'
		});

		site.frontpageCarousel.setVideoHeight();

		$(window).on('resize', function() {
			setTimeout(function() {
				site.frontpageCarousel.setVideoHeight();
			}, 400);
		});
	},

	playCurrentVideo: function(e) {
		var currentIndex = e.relatedTarget.current();
		var video = $('.frontpage__carousel video').get(0);
		if (video) {
			video.pause();
		}
		if (currentIndex === 0 || currentIndex) {
			var $currentSlide = $('.frontpage__carousel .owl-item').eq(currentIndex);
			var currentVideo = $currentSlide.find('video').get(0);
			if (currentVideo) {
				currentVideo.play();
			}
		}
	},

	setVideoHeight: function() {
		var banner = $('.frontpage__banner');
		if (banner.length) {
			height = banner[0].scrollHeight;
			var video = $('.frontpage__carousel video');
			if (video.length) {
				video.css('height', height);
			}
		}
	},

	replaceCarouselHtml: function($newHtml) {
		site.frontpageCarousel.$carousel
			.trigger('replace.owl.carousel', $newHtml)
			.trigger('refresh.owl.carousel')
			.trigger('next.owl.carousel')
			.trigger('prev.owl.carousel');
	},

	initialState: function() {
		site.frontpageCarousel.replaceCarouselHtml(site.frontpageCarousel.$initialCarouselHtml);
	},

	hotelState: function(url) {
		$('.frontpage__banner').addClass('hlada');
		$.ajax({
			url: url,
			success: function(r) {
				if (r.images) {
					site.frontpageCarousel.replaceCarouselHtml(r.images);
				}
				$('.frontpage__banner .hotelDescription').remove();
				$('.frontpage__banner .hotelLink').remove();
				$('.frontpage__banner .buttons').prepend(r.hotelLink);
				if (r.hotelDescription) {
					$('.frontpage__banner .content .innerWrap').prepend(r.hotelDescription);
				}
				$('.frontpage__banner .hotelLogo').remove();
				if (r.hotelLogo) {
					$('.frontpage__banner .carousel__wrap').append(r.hotelLogo);
				}
				const offersElement = $('.frontpage__banner a.offers');
				offersElement.attr('href', offersElement.data('url'));
				offersElement.removeClass('hidden');
				if (r.hotelOffersUrl) {
					offersElement.attr('href', r.hotelOffersUrl);
				}
				else {
					offersElement.addClass('hidden');
				}
				setTimeout(function() {
					$('.frontpage__banner').removeClass('hlada');
				}, 800);
			}
		});
	}
};

site.calendar = {
	init: function() {
		var $body = $('body');
		if ($body.is('.calendarOverview')) {
			MoyaLoader.all([
				'/static/themes/2019/js/isotope.pkgd.min.js',
				'/static/themes/2019/js/scrollspy.min.js',
			]).then(function () {
				this.calendarFilter();
				this.calendarScrollSpy();
			});
		}
		if ($body.is('.calendarView')) {
			this.calendarScroll();
			this.calendarMinHeight();
			$(window).on('resize', function() {
				site.calendar.calendarMinHeight();
			});
		}
	},

	frontpage: function() {
		site.owl.init('.eventList', {
			loop: true,
			dots: false,
			nav: true,
			navText: ['', ''],
			smartSpeed: 700,
			responsive: {
				0: {
					items: 1
				},
				993: {
					items: 3
				}
			},
			lazyLoad: true,
			lazyLoadEager: 1
		});
	},

	view: function() {
		site.owl.init('.imagesWrap.carousel', {
			items: 1,
			dots: false,
			nav: true,
			navText: ['', ''],
			animateOut: 'fadeOut',
			loop: true,
			lazyLoad: true
		});
	},

	calendarFilter: function() {
		var $grid = $('.events');
		var $categoryFilterBtns = $('#categoryFilter .btn');

		$grid.isotope({
			itemSelector: '.event',
			layoutMode: 'fitRows',
			resizable: false
		});

		$categoryFilterBtns.on('click', function() {
			var $monthgroup = $('.monthGroup'),
				$filterValue = $(this).attr('data-filter'),
				$yearFilterButtons = $('#yearFilter .btn');
			$categoryFilterBtns.removeClass('active');
			$yearFilterButtons.attr('disabled', false);
			$(this).addClass('active');
			$monthgroup.show();

			$monthgroup.each(function() {
				var $eventsToBeShown = $(this).find($filterValue),
					$month = $(this).find('.month').attr('id');
				if (!$eventsToBeShown.length) {
					$(this).hide();
					var $anchor = $('a[href="#' + $month + '"]');
					$anchor.attr('disabled', true);
				}
			});
			$grid.isotope({filter:$filterValue});
		});

		var hash = location.hash,
			hashButtonWasClicked = false;
		if (hash) {
			hash = '.' + hash.substr(1);
			var filterButton = $('button[data-filter="' + hash + '"]');

			if (filterButton.length) {
				filterButton.click();
				hashButtonWasClicked = true;
			}
		}
		if (!hashButtonWasClicked) {
			$('button[data-filter="*"]').click();
		}
	},

	calendarScroll: function() {
		$(window).on('scroll', function() {
			var target = $('#below');
			if (!target.length) {
				target = $('footer');
			}
			var	eventInfo = $('.event__info'),
				viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
				offset = (viewportHeight - eventInfo[0].scrollHeight) / 2,
				targetIsVisible = elementOnScreen(target, offset);
			if (targetIsVisible) {
				eventInfo.addClass('stuck');
			} else {
				eventInfo.removeClass('stuck');
			}
		});
	},

	calendarScrollSpy: function() {
		$('body').scrollspy({target: '#yearFilter'});

		$('#yearFilter a, .calendar__up').on('click', function (e) {
			if (!$(this).attr('disabled')) {
				e.preventDefault();
				$('html, body').animate({scrollTop: $($(this).attr('href')).offset().top - 100}, 400);
			}
		});

		$(window).on('activate.bs.scrollspy', function (e) {
			history.replaceState({}, "", $("a[href^='#']", e.target).attr("href"));
		});
	},

	calendarMinHeight: function() {
		$('#calendar.view').css('min-height', $('.event__info')[0].scrollHeight - 200)
	}
};

site.frontpage = {
	init: function() {
		site.frontpageCarousel.init();
		site.sticky.box('.banner__brands', 'showBookNow', 300);
		site.calendar.frontpage();
	},

	animation: function() {
		// Photo duo
		var $photoDuo = $('.photoDuo__images'),
			delay = .7;
		$('.photoDuo__image', $photoDuo).each(function(index) {
			$(this).css({
				'transition-delay': (delay*index) + 's'
			})
		});

		MoyaLoader.all([
			'/static/themes/2019/js/jquery.waypoints.min.js',
		]).then(function () {
			$photoDuo.waypoint(function() {
				$photoDuo.addClass('inView');
			}, {
				offset: '100%'
			});

			delay = .1;
			var $trending = $('.frontpageBoxes .items'),
				$trendingItems = $('.item', $trending);
			$trendingItems.each(function(index) {
				$(this).css({
					'transition-delay': delay*((index*2)) + 's'
				})
			});
			var $delayTimeout = 400 + ((delay * $trendingItems.length) * 1000);
			$trending.waypoint(function() {
				$trending.addClass('inView');
				setTimeout(function() {
					$trendingItems.css({
						'transition-delay': '0s'
					});
				}, $delayTimeout);
			}, {
				offset: '70%'
			});
		});
	}
};

site.hotels = {
	defaultSabreID: '',
	roomCodename: null,

	hotelsOverview: function() {
		MoyaLoader.all([
			'/static/themes/2019/js/oms.min.js',
		]).then(function () {
			$(window).on('load', function () {
				var mti = google.maps.MapTypeId,
					omsOptions = {
						markersWontMove: true,
						markersWontHide: true,
						keepSpiderfied: true,
						circleFootSeparation: 25,
						legColors: {
							'usual': {},
							'highlighted': {}
						},
						nearbyDistance: 30
					},
					gMap = moya.map.gMap,
					legColors = omsOptions.legColors;

				legColors.highlighted[mti.HYBRID] = legColors.highlighted[mti.SATELLITE] =
					legColors.highlighted[mti.TERRAIN] = legColors.highlighted[mti.ROADMAP] = '#d17b00';

				var oms = new OverlappingMarkerSpiderfier(gMap, omsOptions);
				$.each(moya.map.markers, function () {
					var $marker = this;
					oms.addMarker($marker);
					$marker.addListener('spider_click', function () {
						var target = getElementFromDataTitleAttribute(this.title);
						$('html, body').animate({
							scrollTop: target.offset().top - 150
						}, 500);
					});
				});
				handleMapFilter();
				$('.filterControls a').on('click', function () {
					handleMapFilter($(this));
				});

				function handleMapFilter($element) {
					var gMap = moya.map.gMap;
					if (!$element) {
						$element = $('.filterControls a.selected');
						if ($element.is('.all')) {
							return;
						}
					}
					if (!$element.is('.selected') || $element.is('.all')) {
						gMap.setZoom(6);
						gMap.panTo(new google.maps.LatLng(64.993295, -18.51368));
					}
					var bounds = new google.maps.LatLngBounds();
					$.each(moya.map.markers, function () {
						this.setVisible(true);
						var hotelCard = getElementFromDataTitleAttribute(this.title);
						if (hotelCard.is('.hide')) {
							this.setVisible(false);
						}
						else {
							bounds.extend(this.getPosition())
						}
					});

					// Add invisible markers so fitBounds doesn't zoom to much
					if (((bounds.getNorthEast().lat() - bounds.getSouthWest().lat()) < 0.006) &&
						((bounds.getNorthEast().lng() - bounds.getSouthWest().lng()) < 0.006)) {
						var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
						var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
						bounds.extend(extendPoint1);
						bounds.extend(extendPoint2);
					}
					gMap.fitBounds(bounds);
				}
			});
		});

		$('.hotel__bookNow').on('click', function(e) {
			e.preventDefault();
			site.hotels.bookingSetHotel($(e.target).data('sabreid'));
			$('#searchBtn', '#quickbookingDropdown').trigger('click');
		});

		function getElementFromDataTitleAttribute(title) {
			return $("*[data-name='" + title + "']");
		}
	},
	hotelView: function(sabreID) {
		var $toggler = $('#hotel__features__toggle');
		$toggler.on('click', function() {
			$(this).toggleClass('expanded');
			$('#hotel__features__list').toggleClass('expanded');
		});
		$(document).on('click touchstart', function(e)
		{
			if ($toggler.is('.expanded')) {
				var container = $('#hotel__features__list, #hotel__features__toggle');

				if (!container.is(e.target) && container.has(e.target).length === 0) {
					$toggler.removeClass('expanded');
					$('#hotel__features__list').removeClass('expanded');
				}
			}
		});

		site.owl.init('.hotel__banner__images.carousel', {
			items: 1,
			dots: false,
			nav: true,
			navText: ['', ''],
			animateOut: 'fadeOut',
			loop: true,
			lazyLoad: true,
			onInitialized: site.hotels.bannerInitalized,
			onTranslated: site.hotels.bannerTranslated,
		});

		$('.hotel__icon[aria-haspopup]').each(function() {
			$(this).on('click', function() {
				const thisId = $(this).attr('id');
				if (thisId !== 'toggle-hotel-features') {
					$(`.hotel__icon[aria-haspopup]:not(#${thisId})`).each(function() {
						$(this).attr('aria-expanded', false);
						const target = $('#' + $(this).attr('aria-controls'));
						target.removeClass('open');
					});
				}

				const isExpanded = $(this).attr('aria-expanded');
				$(this).attr('aria-expanded', isExpanded === 'true' ? 'false' : 'true');

				const target = $('#' + $(this).attr('aria-controls'));
				target.toggleClass('open');
			});

			let find = $(this).next().find('.feature__detail_close');
			$(find).on('click', function () {
				$(this).parent().removeClass('open')
				const isExpanded = $(this).parent().prev().attr('aria-expanded');
				$(this).parent().prev().attr('aria-expanded', isExpanded === 'true' ? 'false' : 'true');
			});
		});
	},

	bannerInitalized: function (asdf) {
		site.hotels.setOwlButtons()
	},
	bannerTranslated: function () {
		site.hotels.setOwlButtons()
	},
	setOwlButtons: function () {
		const currentItem = document.querySelector('.hotel__banner__images.carousel .owl-item.active');
		const prevItem = currentItem.previousSibling;
		const nextItem = currentItem.nextSibling;
		let prevTitle = '';
		if (prevItem) {
			prevTitle = prevItem.firstChild.dataset.title;
		}
		let nextTitle = '';
		if (nextItem) {
			nextTitle = nextItem.firstChild.dataset.title;
		}

		site.hotels.updateMaxWidth(document.querySelector('.hotel__banner__images.carousel .owl-prev'), prevTitle);
		site.hotels.updateMaxWidth(document.querySelector('.hotel__banner__images.carousel .owl-next'), nextTitle);
	},

	updateMaxWidth: function (elm, title) {
		if (title === '') {
			elm.innerHTML = title;
			elm.style.maxWidth = 60 + 'px';
			return
		}
		const canvas = document.createElement("canvas");
		const context = canvas.getContext("2d");
		context.font = '16px Barlow';
		const width = context.measureText(title).width;
		const finalWidth = Math.ceil(width)+ 160;
		if (elm.style.maxWidth !== finalWidth) {
			elm.innerHTML = title;
			elm.style.maxWidth = finalWidth + 'px';
		}
	},

	roomsOverview: function() {
		site.owl.init('.room__images.carousel', {
			items: 1,
			dots: false,
			nav: true,
			navText: ['', ''],
			animateOut: 'fadeOut',
			loop: true,
			lazyLoad: true
		});

		site.hotels.roomBookNow();
	},

	roomBookNow: function() {
		$('.room__bookNow').on('click', function(e) {
			var room = $(this).closest('.rooms.item');
			if (!room.length) {
				room = $('.rooms.item');
			}
			var maxPersons = room.data('max-persons');
			if (maxPersons === 1) {
				site.hotels.bookingSetAdultCount(1);
			}
			site.hotels.bookingSetDefaultHotel();
			site.hotels.bookingSetRoom($(e.target).data('roomcodename'));
			$('#searchBtn', '#quickbookingDropdown').trigger('click');
		});
	},

	roomView: function(roomCodename) {
		if (roomCodename && roomCodename !== '') {
			site.hotels.roomCodename = roomCodename;
		}

		$('[data-fancybox="room"]').fancybox({
			buttons: [
				"slideShow",
				"fullScreen",
				"thumbs",
				"close"
			],
			animationDuration: 1200,
			transitionDuration: 1200,
			transitionEffect: "fade",
			caption: function() {
				return $(this).next('figcaption').html();
			},
			afterLoad: function() {
				site.hotels.roomBookNow();
			}
		});
		$('.imageBtn').on('click', function() {
			$('*[data-fancybox]')[0].click();
		});

		site.hotels.roomBookNow();
	},

	offersOverview: function() {
		var $grid = $('.offers__cards'),
			$offerGroups = $('.offer__group'),
			$offerFilterBtns = $('.offer__filters .btn'),
			$offers = $('.offer'),
			$window = $(window);

		$grid.isotope({
			itemSelector: '.offer',
			layoutMode: 'fitRows',
			resizable: false
		});

		$grid.imagesLoaded().progress( function() {
			$grid.isotope('layout');
		});

		$offerFilterBtns.on('click', function() {
			$offerFilterBtns.removeClass('active');
			$(this).addClass('active');
			var $filterValue = $(this).attr('data-filter');
			location.hash = 'hotel=' + $filterValue;
		});

		$(window).on( 'hashchange', handleHashChange );

		handleHashChange();
		setOfferMinHeight();

		function getHashFilter() {
			var hash = location.hash,
				matches = hash.match( /hotel=([^&]+)/i ),
				hashFilter = matches && matches[1];
			return hashFilter;
		}

		function handleHashChange() {
			var hashFilter = getHashFilter();

			$grid.isotope({
				itemSelector: '.offer',
				layoutMode: 'fitRows',
				filter: hashFilter
			});

			function onLayout(items) {
				$(items).each((i, item) => {
					const style = item.element.getAttribute('style');
					if (style.includes('left: ')) {
						item.element.classList.add('megaAbs');
					}
					else {
						item.element.classList.remove('megaAbs');
					}
				})
			}
			$grid.isotope('on', 'arrangeComplete', onLayout);

			if (!hashFilter) {
				hashFilter = '*';
			}

			$offerFilterBtns.removeClass('active');
			$offerFilterBtns.filter('[data-filter="' + hashFilter + '"]').addClass('active');

			$offerGroups.removeClass('hideMe');
			$offerGroups.each(function() {
				var $offersToBeShown = $(this).find(hashFilter);
				if (!$offersToBeShown.length) {
					$(this).addClass('hideMe');
				}
			});

		}

		function setOfferMinHeight() {
			site.height.equalHeight($offers);
		}
	},

	offerView: function() {
		$('[data-fancybox="offer"]').fancybox({
			buttons: [
				"slideShow",
				"fullScreen",
				"thumbs",
				"close"
			],
			animationDuration: 1200,
			transitionDuration: 1200,
			transitionEffect: "fade",
		});
		$('.imageBtn').on('click', function() {
			$('*[data-fancybox]')[0].click();
		});
	},

	hotelOffersBox: function() {
		if (!$('.box_extras_hotel_offers').length) {
			return;
		}
		site.owl.init('.box_extras_hotel_offers .offers', {
			items: 1,
			dots: false,
			nav: true,
			navText: ['', ''],
			animateOut: 'slideOutDown',
			animateIn: 'fadeIn',
			autoHeight: true,
			lazyLoad: true
		});
	},

	offersBox: function() {
		if (!$('.box_extras_offers').length) {
			return;
		}
		site.owl.init('.box_extras_offers .offers__cards', {
			items: 3,
			dots: false,
			nav: true,
			loop: true,
			navText: ['', ''],
			smartSpeed: 700,
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2,
					margin: 20
				},
				992: {
					items: 3,
					margin: 30
				}
			},
			lazyLoad: true,
			lazyLoadEager: 1
		});
		site.height.equalHeight('.offers__cards .offer');
	},

	sort: function() {
		var codenameSelect = $('#hotelCodename');
		codenameSelect.change(function() {
			var codename = $(this).val(),
				options = $('#sortList > li');
			if (codename === 'all') {
				options.show();
				return;
			}
			options.each(function() {
				if ($(this).is('.' + codename)) {
					$(this).show();
				} else {
					$(this).hide();
				}
			});
		}).change();
	},

	bookingOptions: null,
	uiLoaded: false,
	quickbooking: function(options) {
		if (document.body.classList.contains('loggedIn')) {
			this.uiLoaded = true;
		}
		if (!this.uiLoaded) {
			MoyaLoader.all([
				'https://static.stefna.is/js/jquery/ui/js/jquery-ui-1.11.2.min.js',
				'https://static.stefna.is/js/jquery/ui/css/moya/jquery-ui-1.11.2.min.css',
			]).then(function () {
				site.hotels.uiLoaded = true;
				site.hotels.quickbooking(options);
			});
			return;
		}

		var $body = $('body');
		site.hotels.bookingOptions = JSON.parse(options);

		var $hotel = $('#elm_hotel');
		$body.on('click', function() {
			$('.ui-corner-all').addClass('toggle_skip_body_click');

			if ($body.hasClass('frontpage') && $hotel && $hotel.hasClass('open')) {
				$hotel.removeClass('open');
			}
		});

		var toggleElement = document.querySelector('.nav__buttons .navbutton a');
		if ($body.hasClass('frontpage')) {
			$(toggleElement).on('click', function(e) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: document.body.clientWidth > 768 ? 0 : 330,
				}, 400);
			});
		}
		else {
			site.maxHeight.init('#quickbookingDropdown');
			var openElement = document.querySelector('#quickbookingDropdown');
			toggle.create(toggleElement, openElement, 'quickbooking', {
				closeOnBodyClick: false,
			});
		}

		site.hotels.bookingCheckForPopup();

		$body.on('click', function (e) {
			if ($body.hasClass('quickbooking-open') && !$(e.target).is('.ui-corner-all')) {
				$body.removeClass('quickbooking-open');
			}
		});

		var dateFormat = 'yy-mm-dd';
		var datepickerFormat = 'dd.mm.yy';

		var $bookingForm = $('#quickbookingDropdown form');
		$('.elm_cancel button', $bookingForm).click(function(e) {
			var lang = $('html').attr('lang'),
				langUrl = '/en/find-existing-reservation';
			if (String(lang) === 'is') {
				langUrl = '/is/breyta-bokun';
			}
			e.preventDefault();
			document.location.href= langUrl;
		});

		$('#quickbookingDropdown #arrive').datepicker({
			dateFormat: datepickerFormat,
			numberOfMonths:3,
			minDate: new Date(),
			beforeShowDay: function(date) {
				var currentDate = new Date();
				currentDate.setHours(0);
				currentDate.setMinutes(0);
				currentDate.setSeconds(0);
				currentDate.setMilliseconds(0);
				if (date >= currentDate) {
					return [true, ''];
				}
				else {
					return [false, ''];
				}
			},
			beforeShow: function(input,inst) {
				var qheight = $('#quickbookingDropdown').outerHeight();
				if(qheight < 732) {
					$('#quickbookingDropdown #arrive').datepicker('option','numberOfMonths',2);
				}
				inst.dpDiv.addClass('ui-ih toggle_skip_body_click ui-ih-arrive ').removeClass('.ui-corner-all').css('height',qheight)
				$(this).parents('.elm').addClass('open');
			},
			onSelect: function(dateText, inst) {
				var nextDay = $('#quickbookingDropdown #arrive').datepicker('getDate');
				nextDay.setDate(nextDay.getDate() + 1);
				var depart = $('#quickbookingDropdown #depart').datepicker('getDate');
				if (depart < nextDay) {
					$('#quickbookingDropdown #depart').val($.datepicker.formatDate(datepickerFormat, nextDay)).trigger('change');
				}
			},
			onClose: function(input,inst) {
				$(this).parents('.elm').removeClass('open');
				$('#quickbookingDropdown #depart').focus();
			}
		}).val($.datepicker.formatDate(datepickerFormat, new Date()));
		var nextDay = new Date();
		nextDay.setDate(new Date().getDate() + 1);
		$('#quickbookingDropdown #depart').datepicker({
			dateFormat: datepickerFormat,
			numberOfMonths:3,
			minDate: nextDay,
			beforeShowDay: function(date) {
				var nextDay = $('#quickbookingDropdown #arrive').datepicker('getDate');
				nextDay.setDate(nextDay.getDate() + 1);
				nextDay.setHours(0);
				nextDay.setMinutes(0);
				nextDay.setSeconds(0);
				nextDay.setMilliseconds(0);

				if (date >= nextDay) {
					return [true, ''];
				}
				else {
					return [false, ''];
				}
			},
			beforeShow: function(input,inst) {
				var qheight = $('#quickbookingDropdown').outerHeight();
				if(qheight < 732) {
					$('#quickbookingDropdown #depart').datepicker('option','numberOfMonths',2);
				}
				inst.dpDiv.addClass('ui-ih toggle_skip_body_click').removeClass('.ui-corner-all').css('height',qheight);
				$(this).parents('.elm').addClass('open');
			},
			onClose: function(input,inst) {
				$(this).parents('.elm').removeClass('open');
				$('#quickbookingDropdown #hotelDesc').addClass('closed');
			}
		}).val($.datepicker.formatDate(datepickerFormat, nextDay));

		site.hotels.altdestMap = JSON.parse($('#altdestMap').val());

		$('input, select', $bookingForm).on('change', function(e) {
			if ($(e.target).is('#hotel')) {
				site.hotels.bookingRemoveError();
				site.hotels.roomCodename = null;
				if (site.hotels.altdestMap && site.hotels.altdestMap.hasOwnProperty(this.value)) {
					$('#altdest').val(site.hotels.altdestMap[this.value]);
				}
				if (this.value.indexOf('http') === 0) {
					$bookingForm.attr('action', this.value);
					$bookingForm.addClass('limited');
					$('input.datepicker, select.min', $bookingForm).attr('disabled', 'disabled');
					return false;
				}
				else {
					$bookingForm.removeClass('limited');
					$('input.datepicker, select.min', $bookingForm).removeAttr('disabled');
					site.hotels.setBookingDates(this.value);
				}
			}

			if (site.hotels.defaultSabreID.indexOf('http') === 0) {
				$bookingForm.attr('action', site.hotels.defaultSabreID);
				return false;
			}

			var url = $bookingForm.data('url') + '?';
			var values = {};
			$.each($bookingForm.serializeArray(), function(k, v) {
				values[v.name] = v.value;
			});
			if (values.hotel == -1) {
				url += 'Chain=15503&';
				delete values.hotel;
			}
			else {
				values.level = 'hotel';
			}
			if (values.altdestMap) {
				delete values.altdestMap;
			}

			var arrivalDate = $('#arrive', $bookingForm).datepicker('getDate');
			var departureDate = $('#depart', $bookingForm).datepicker('getDate');
			values.arrive = $.datepicker.formatDate(dateFormat, arrivalDate);
			values.depart = $.datepicker.formatDate(dateFormat, departureDate);
			// values.rooms = String('');
			// values.numb_rooms = String(0);

			if ($("#hotel option:selected" ).text().indexOf('Edda') !== -1) {
				values.themeCode = 'edda';
			}

			$.each(values, function(k, v) {
				if (v && v.length > 0) {
					url += k + '=' + v + '&';
				}
			});
			url = url.substr(0, url.length-1);
			$bookingForm.attr('action', url);
		});
		$('#hotel').trigger('change');
		$('#adult').trigger('change');

		$bookingForm.submit(function(e) {
			e.preventDefault();
			var url = $bookingForm.attr('action');
			if (site.hotels.roomCodename) {
				url += '&rooms=1&room=' + site.hotels.roomCodename;
				site.hotels.roomCodename = null;
			}
			if (parseInt($('#hotel').val()) === -1) {
				site.hotels.bookingAddError();
				return;
			} else {
				site.hotels.bookingRemoveError();
			}

			try {
				var gaTracker = ga && ga.getAll()[0];
				if (gaTracker) {
					var gaLinkerParam = gaTracker.get('linkerParam');
					if (gaLinkerParam) {
						url += '&' + gaLinkerParam;
					}
				}
			}
			catch (e) {}
			window.open(url);
		});

		site.hotels.initHotelSelect();
	},

	initHotelSelect: function() {
		var $body = $('body'),
			$hotel = $('#hotel'),
			$hotelElm = $hotel.closest('div');
		$hotelElm.removeClass('eType_select').addClass('optGroupMulti');
		$hotelElm.append('<div id="hotelMulti" />');
		var $hotelMulti = $('#hotelMulti');
		$hotelMulti.on('click', function(e) {
			e.stopPropagation();
		});
		$hotelMulti.append('<div class="wrap" />');
		$('label', $hotelElm).attr('id', 'hotelMultiLabel');
		$('.lmnt', $hotelElm).append('<a href="#" class="multiToggle" aria-labelledby="hotelMultiLabel" />');

		$('optgroup', $hotel).each(function(){
			var $div = $('<div class="group" />');
			var url = $(this).attr('id').replace('-optgroup-', '#');
			var lang = $('html').attr('lang');
			url = lang === 'en' ? url.replace('hotel', 'hotels') : url;
			$div.append(`<a class="label" href="/${lang}/${url}">${$(this).attr('label')}</a>`);
			$div.addClass($(this).attr('id'));
			var $ul = $('<ul class="menu" />');
			$('option', $(this)).each(function(){
				$($ul).append('<li><a href="#" data-value="'+$(this).val()+'">'+$(this).text()+'</a></li>');
			});

			$div.append($ul);
			$('.wrap', $hotelMulti).append($div);
		});

		const $bookingDropdown = $('#quickbookingDropdown');
		const $bookingForm = $('form', $bookingDropdown);
		const hotelCodenames = $bookingForm.data('codenames');

		const updateSelectByText = (elementSelector, text) => {
			var selectElement = document.querySelector(elementSelector);
			var options = selectElement.options;
			for (var i = 0; i < options.length; i++) {
				if (options[i].text.trim() === text.trim()) {
					selectElement.selectedIndex = i;
					return;
				}
			}
		}

		$('li a', '.optGroupMulti').on('click', function(e) {
			e.preventDefault();
			var $this = $(this);
			$('li a', $hotelMulti).removeClass('selected');
			$this.addClass('selected');
			updateSelectByText('#hotel', $this.text());
			$hotel.trigger('change');
			$hotelElm.removeClass('open');

			if (!$('body').hasClass('frontpage')) {
				$('#quickbookingDropdown #arrive').focus();
			}
		});

		$('a.multiToggle').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			$hotelElm.toggleClass('open');
		});

		$hotel.on('change', function() {
			if ($body.hasClass('frontpage')) {
				const baseUrl = $bookingDropdown.data('url');
				const codename = hotelCodenames[$('option:selected', $(this)).text()];
				if (baseUrl && codename) {
					site.frontpageCarousel.hotelState(baseUrl.replace('%codename%', codename));
				}
				//Scroll to top on hotel change in mobile
				if (document.body.clientWidth < 768) {
					$('html, body').animate({
						scrollTop: 0,
					}, 400);
				}
			}
		});
	},

	bookingSetHotel: function(sabreID) {
		site.hotels.defaultSabreID = String(sabreID);
		site.hotels.bookingSetDefaultHotel();
	},
	bookingCheckForPopup: function () {
		// This function is to prevent the booknow popup from popping up when
		// the hotel is not using the synxis booking
		const url = site.hotels.defaultSabreID;

		if (url.indexOf('http') === 0) {
			const bookNowButton = document.querySelector('.nav__buttons .navbutton a');
			const newBookNowButton = bookNowButton.cloneNode(true);
			bookNowButton.parentNode.replaceChild(newBookNowButton, bookNowButton); // Removing all action listeners

			// Add new action listener
			newBookNowButton.addEventListener('click', (ev) => {
				ev.preventDefault();
				$('#quickbookingDropdown form').submit();
			});
		}
	},

	bookingSetAdultCount: function(adultCount) {
		$('#adult').val(String(adultCount)).trigger('change');
	},

	bookingSetDefaultHotel: function() {
		var $bookingForm = $('#quickbookingDropdown form');
		$('select#hotel option[value="' + site.hotels.defaultSabreID + '"]', $bookingForm).attr('selected', true);
		if (site.hotels.defaultSabreID.indexOf('http') === 0) {
			$bookingForm.addClass('limited');
			$('input.datepicker, select.min', $bookingForm).attr('disabled', 'disabled');
		}
		$('select#hotel', $bookingForm).trigger('change');
	},

	bookingSetRoom: function(roomCodename) {
		site.hotels.roomCodename = roomCodename;
	},

	bookingAddError: function() {
		if ($('.bookingError').length) {
			return;
		}
		var $hotel = $('#hotel'),
			$hotelElm = $hotel.closest('div'),
			lang = $('html').attr('lang'),
			langString = 'Please choose hotel';
		if (String(lang) === 'is') {
			langString = 'Vinsamlegast veldu h&oacute;tel';
		}
		$hotel.after('<span class="bookingError">' + langString + '</span>');
		$hotelElm.addClass('open');
	},

	bookingRemoveError: function() {
		$('.bookingError').remove();
	},

	setBookingDates: function(sabreID) {
		if (parseInt(sabreID) === -1) {
			return;
		}

		var minDate, maxDate;

		if (site.hotels.bookingOptions.opening.hasOwnProperty(sabreID)) {
			var opening = site.hotels.bookingOptions.opening[sabreID];
			minDate = new Date(opening.openFrom);
			maxDate = new Date(opening.openTo);
		}
		else {
			minDate = new Date();
			maxDate = null;
		}

		var nextDate = new Date(minDate);
		nextDate.setDate(nextDate.getDate() + 1);

		$('#quickbookingDropdown #arrive')
			.datepicker('option', 'minDate', minDate)
			.datepicker('option', 'maxDate', maxDate);
		$('#quickbookingDropdown #depart')
			.datepicker('option', 'minDate', nextDate)
			.datepicker('option', 'maxDate', maxDate);
	}
};

site.attractions = {
	init: function() {
		site.owl.init('.attractions > .contentWrap', {
			items: 4,
			margin: 30,
			draggable: false,
			dots: false,
			nav: true,
			navText: ['', ''],
			smartSpeed: 700,
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 3
				},
				1150: {
					items: 4
				}
			},
			lazyLoad: true,
			lazyLoadEager: 1
		});

		$(window).on('load', function() {
			$.each(moya.map.markers, function() {
				var $marker = this;
				$marker.addListener('click', function() {
					var $title = this.title;
					var $idx = $('.attraction__title:contains("' + $title + '")').closest('.owl-item').index();
					$('.attractions > .contentWrap').trigger('to.owl.carousel', $idx);
				});
			});
		});
	}
};

site.promo = {
	init: function() {
		site.promo.vimeoIsActive();
		$('.promo__button').on('click', function() {
			var $id = $(this).attr('data-id');
			$('.promo__item, .promo__button').removeClass('active');
			$('#' + $id).addClass('active');
			$(this).addClass('active');
			site.promo.vimeoIsActive();
		});
	},
	vimeoIsActive: function() {
		var isActive = $('.promo__item.active').is('.vimeo');
		if (isActive) {
			$('.promo__items').addClass('vimeoActive');
		} else {
			$('.promo__items').removeClass('vimeoActive');
		}
	}
};

site.svg = {
	init: function () {
		/* Disabled
		$('#main img[src*=".svg"]:not(".keep")').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
		 */
	}
};

site.activityCarousel = {
	init: function() {
		if (!$('.activity__carousel__slides').length) {
			return;
		}
		site.owl.init('.activity__carousel__slides', {
			items: 1,
			loop: true,
			nav: true,
			navText: ['', ''],
			dots: false,
			smartSpeed: 600,
			onInitialized: site.activityCarousel.initialized,
			onTranslated: site.activityCarousel.translated,
			lazyLoad: true,
			lazyLoadEager: 1,
		});

		var $filters = $('.linksFilter > a[href!="#"]');
		if ($filters.length) {
			$filters.on('click', function(e) {
				e.preventDefault();
				$filters.removeClass('active');
				$(this).addClass('active');
				var $filterValue = $(this).attr('href').substr(1);

				$('.activity__carousel__group').removeClass('active');
				$('.activity__carousel__group[data-codename="' + $filterValue + '"]').addClass('active');
				site.activityCarousel.setPrevNext();
			});
			$filters.first().click();
		}
	},

	setPrevNext: function() {
		var $group = $('.activity__carousel__group.active');
		if (!$group.length) {
			$group = $('.activity__carousel__group');
		}
		var $owl = $group.find('.activity__carousel__slides');
		var activeItem = $owl.find('.owl-item.active'),
			prevTitle = activeItem.prev().find('.activity__carousel__slide').attr('data-name'),
			nextTitle = activeItem.next().find('.activity__carousel__slide').attr('data-name');
		$owl.find('.owl-prev').text(prevTitle);
		$owl.find('.owl-next').text(nextTitle);
	},

	counter: function ($event) {
		var $counter = $('.activity__carousel__slides__wrapper #counter');
		var items = $event.item.count;
		var item = $event.item.index + 1;

		if(item > items) {
			item = item - items
		}
		$counter.html(item + '/' + items).fadeIn();
	},

	initialized: function(e) {
		site.activityCarousel.counter(e);
		site.activityCarousel.setPrevNext();
	},

	translated: function(e) {
		site.activityCarousel.counter(e);
		site.activityCarousel.setPrevNext();
	}
};

site.extrasDefault = {
	init: function() {
		site.owl.init('.extras__default__images.carousel', {
			items: 1,
			dots: false,
			nav: true,
			loop: true,
			navText: ['', ''],
			animateOut: 'fadeOut',
			lazyLoad: true
		});
	}
};

site.ihFilter = {
	init: function() {
		site.maxHeight.init('.ih__filter:not(#yearFilter)');
		var toggleElement = document.querySelector('#filter__toggler');
		var openElement = document.querySelector('#ih__filter');
		toggle.create(toggleElement, openElement, 'ihFilter', {
			closeOnBodyClick: false,
		});

		var $filterBtn = $('.btn-primary[data-filter]'),
			$filterToggler = $('#filter__toggler'),
			initialLabel = $filterToggler.data('label');
		let tempTitle = document.title;

		$(document).ready(function() {
			let activeButton = $('.active');
			if (activeButton) {
				document.title = tempTitle + ' | ' + activeButton.text().trim();
			}
		});

		$filterBtn.on('click', function() {
			var isAllFilter = $(this).data('filter').toString() === '*',
				filterTogglerLabel = isAllFilter ? initialLabel : $(this).text();
			document.title = tempTitle + ' | ' + filterTogglerLabel.trim();
			$filterToggler.text(filterTogglerLabel);
			$filterToggler.click();
		});
	}
};

site.ihLinksFilter = {
	init: function() {
		let tempTitle = document.title;
		var $filterBtn = $('.ihLinksFilter > a');

		$(document).ready(function() {
			let activeButton = $('.ihLinksFilter .selected');
			if (activeButton) {
				document.title = tempTitle + ' | ' + activeButton.text().trim();
			}
		});

		$filterBtn.on('click', function() {
			document.title = tempTitle + ' | ' + $(this).text().trim();
		});
	}
}

site.gcertFilters = {
	init: function() {
		let tempTitle = document.title;
		let ret = '';
		let $filterMenu = $('.filter.menu li.selected');
		let $filterBtn = $('.filter.menu li > a');

		if ($filterMenu.length > 0) {
			$filterMenu.each(function(index, e) {
				let filterText = $(this).text().trim();
				if (index !== $filterMenu.length - 1) {
					filterText += ' | ';
				}
				ret += filterText;
			});
			document.title = tempTitle + ' | ' + ret;
		}
		$filterBtn.on('click', function() {
			let ogTitle = document.title.split('|').slice(0, 2).join('|');
			document.title = ogTitle + ' | ' + $(this).text().trim();
			let ret = '';
			$('.filter.menu li.selected > a, .filter.menu li > a.selected').each(function(index, e) {
				ret += ' | ' + $(this).text();
			});
			document.title = ogTitle + ret;
		});
	}
}

site.conferenceSearch = {
	init: function () {
		site.owl.init('.conferenceSearch .box_aitems .items', {
			items: 1,
			dots: false,
			nav: true,
			navText: ['', ''],
			lazyLoad: true,
			smartSpeed: 700,
			animateOut: 'fadeOut'
		});

		site.owl.init('.extras__conference__boxes .extras__images', {
			items: 1,
			dots: false,
			loop: true,
			nav: true,
			navText: ['', ''],
			lazyLoad: true,
			smartSpeed: 500,
			animateOut: 'fadeOut'
		});
	}
};

site.hotelView = {
	init: function () {
		site.owl.init('.box_hotel_rooms .tiles', {
			loop: true,
			dots: false,
			margin: 30,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			nav: true,
			items: 1,
			navText: ["", ""],
			responsive: {
				0: {
					items: 1,
				},
				768: {
					items: 2,
				},
				992: {
					items: 2,
				},
				1024: {
					items: 2,
				}
			},
		});
	}
};

function elementOnScreen (element, offset) {
	var windowBottomEdge = $(window).scrollTop() + $(window).height();
	var elementTopEdge = element.offset().top;
	return elementTopEdge + offset <= windowBottomEdge;
}


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.hotels.hotelOffersBox();
	site.hotels.offersBox();
	site.activityCarousel.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();

		site.frontpage.animation();
	}
	site.sticky.box('body', 'sticky', -70);
	if ($body.is('.calendar') && !$body.is('.admin')) {
		site.calendar.init();
	}
	if (($body.is('.conferenceSearch') || $body.is('.conferenceResults')) && !$body.is('.admin')) {
		site.conferenceSearch.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Use CSS custom property because of bottom navigation bars in mobile
	function setMobileViewportHeight() {
		let mobileViewportHeight = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--mobileViewportHeight', `${mobileViewportHeight}px`);
	}
	setMobileViewportHeight();

	if ($('.ih__filter').length && $('#filter__toggler').length) {
		site.ihFilter.init();
	}

	if ($('.ihLinksFilter').length) {
		site.ihLinksFilter.init();
	}

	if ($('#gcert .filter.menu > li').length) {
		site.gcertFilters.init();
	}

	if ($body.is('.hotelView')) {
		site.hotelView.init();
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
